type Props = {
	children: React.ReactNode;
};

export const SearchByBasicLayout = ({ children }: Props) => (
	<div className="grid grid-cols-1 gap-4 tablet:flex tablet:items-center">{children}</div>
);
